document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[id^="FreeOilButton-"]').forEach(function (button) {
    button.addEventListener('click', function () {
      var sectionId = button.id.replace('FreeOilButton-', '');
      var select = document.getElementById('FreeOilSelect-' + sectionId);
      var note = document.getElementById('FreeOilNote-' + sectionId);
      var diffuserVariantId = button.getAttribute('data-diffuser-variant-id');
      var oilVariantId = select.value;

      button.disabled = true;
      note.textContent = 'Bezig met toevoegen...';
      note.className = 'free-oil-picker__note';

      fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [
            { id: diffuserVariantId, quantity: 1 },
            { id: oilVariantId, quantity: 1 }
          ]
        })
      })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (data) {
              throw new Error((data && data.description) || 'Er ging iets mis');
            });
          }
          return response.json();
        })
        .then(function () {
          note.textContent = 'Toegevoegd! De gratis olie wordt automatisch verrekend bij het afrekenen.';
          note.className = 'free-oil-picker__note free-oil-picker__note--success';
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          if (typeof window.Shopify !== 'undefined' && document.querySelector('cart-notification')) {
            fetch('/cart.js')
              .then(function (r) { return r.json(); })
              .then(function () {
                window.location.href = window.location.origin + '/cart';
              });
          } else {
            window.location.href = window.location.origin + '/cart';
          }
        })
        .catch(function (err) {
          note.textContent = err.message || 'Er ging iets mis, probeer het opnieuw.';
          note.className = 'free-oil-picker__note free-oil-picker__note--error';
          button.disabled = false;
        });
    });
  });
});
